import { useEffect } from "react";
import { useFormikContext } from "formik";

/**
 * Formik validation messages are computed when a field is validated, so switching language
 * would leave any visible errors in the old language. Render this inside a <Formik> to
 * re-validate (only when errors are showing) whenever the language changes.
 */
const RevalidateOnLanguageChange = ({ language }) => {
  const { errors, validateForm } = useFormikContext();
  const hasErrors = Object.keys(errors).length > 0;

  useEffect(() => {
    if (hasErrors) validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return null;
};

export default RevalidateOnLanguageChange;
